import { Button } from '@snowball-tech/fractal/dist/src/components/Button'
import { TabContent } from '@snowball-tech/fractal/dist/src/components/Tabs'
import { UilTrashAlt as DeleteIcon } from '@tooni/iconscout-unicons-react'

import type { MediaTypes } from '../../../types'

import useTranslations from '../../../hooks/useTranslations'

const provider = 'delete'

type Props = {
  type: MediaTypes
  onDelete: (imageUrl: string, provider: string) => void
  enabled?: boolean
}
export default function Delete({ enabled = true, onDelete, type }: Props) {
  const $t = useTranslations()

  if (!enabled) {
    return false
  }

  return (
    <TabContent className="flex flex-col gap-2" name="delete">
      <Button
        fullWidth
        icon={<DeleteIcon />}
        iconPosition="left"
        label={$t(`editor.${type}.loader.${provider}.button`)}
        onClick={() => onDelete('', provider)}
      />
    </TabContent>
  )
}
